import styled from "styled-components";

export const MusicPracticeRoomSelectDateFormStyled = styled.div`
  .input_wrap {
    padding: 0 50px;
    margin-bottom: 24px;
    &.mb_12 {
      margin-bottom: 12px;
    }
    .time_rec_label {
      margin-top: 8px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
    /* placeholder หมายเหตุ สีเทาเหมือน placeholder ของ dropdown ด้านบน (DropdownSelect ใช้ GRAY_17) */
    &.note_wrap textarea::placeholder {
      color: ${({ theme }) => theme.COLORS.GRAY_17};
    }
    &.room_error {
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
  }
  .calendar_wrap {
    margin-bottom: 24px;
    padding: 0 50px;
  }
  .room_rec_label {
    margin-bottom: 20px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }

  .form_title {
    margin-bottom: 20px;
    color: ${({ theme }) => theme.COLORS.BLACK_3};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .button_layout {
    padding: 0 42px;
    display: flex;
    justify-content: center;
    column-gap: 36px;
    .button1 {
      flex: 1;
    }
    .button2 {
      flex: 1;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .input_wrap {
      padding: 0px;
    }
    .calendar_wrap {
      padding: 0px;
    }
    .button_layout {
      padding: 0px;
      column-gap: 16px;
    }
  }
`;
